<template>
  <section class="px-2 font-weight-bold mb-4">
    <p class="color--gray-60 font-weight-bold">{{ item.date }}</p>
    <template
      v-if="(filter === 'all' || filter === 'mallDeposits') && item.mallDeposits.length > 0"
    >
      <v-row class="color--primary-100 font-size--18 subject pb-0">
        <v-col cols="5">플랫폼 입금</v-col>
        <v-col>+{{ commaFormat(sumByProperties(item.mallDeposits, ['amount'])) }}원</v-col>
      </v-row>
      <v-row v-for="row in item.mallDeposits" :key="row.uuid" class="detail">
        <v-col cols="2"></v-col>
        <v-col>
          <span class="color--gray-70 font-weight-bold">{{ row.mallProviderName }}</span>
          &nbsp;
          <span class="font-weight-bold">{{ commaFormat(row.amount) }}원</span>
        </v-col>
      </v-row>
    </template>
    <template v-if="(filter === 'all' || filter === 'repayments') && item.repayments.length > 0">
      <v-row class="color--pinkred-100 subject font-size--18">
        <v-col cols="5">상환</v-col>
        <v-col>
          {{ commaFormat(sumByProperties(item.repayments, ['amount', 'fee', 'vat']) * -1) }}원
        </v-col>
      </v-row>
      <div v-for="row in item.repayments" :key="row.uuid">
        <v-row class="detail">
          <v-col cols="2"></v-col>
          <v-col>
            <span class="color--gray-70 font-weight-bold">사입비 원금</span>
            &nbsp;
            <span class="font-weight-bold">{{ commaFormat(row.amount) }}원</span>
          </v-col>
        </v-row>
        <v-row class="detail">
          <v-col cols="2"></v-col>
          <v-col>
            <span class="color--gray-70 font-weight-bold">이용 수수료</span>
            &nbsp;
            <span class="font-weight-bold">{{ commaFormat(row.fee + row.vat) }}원</span>
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-if="(filter === 'all' || filter === 'refunds') && item.refunds.length > 0">
      <v-row class="subject">
        <v-col cols="5">셀러 반환</v-col>
        <v-col> {{ commaFormat(sumByProperties(item.refunds, ['amount'])) }}원 </v-col>
      </v-row>
      <v-row v-for="row in item.refunds" :key="row.uuid" class="detail">
        <v-col></v-col>
        <v-col>
          <span class="font-weight-bold">{{ commaFormat(row.amount) }}원 </span>
        </v-col>
      </v-row>
    </template>
    <template v-if="(filter === 'all' || filter === 'payments') && item.payments.length > 0">
      <v-row class="subject">
        <v-col cols="5">사입비</v-col>
        <v-col> {{ commaFormat(sumByProperties(item.payments, ['amount'])) }}원 </v-col>
      </v-row>
      <v-row v-for="row in item.payments" :key="row.uuid" class="detail">
        <v-col cols="2"></v-col>
        <v-col>
          <span class="color--gray-70 font-weight-bold">
            <router-link
              :to="{ path: `/payments/${row.uuid}` }"
              id="btn__+ZNc1v0qSk6el0TLqZ6jZA=="
              class="color--gray-70"
            >
              {{ row.wholesalerAccountWholesalerName }}
            </router-link>
          </span>
          &nbsp;
          <span class="font-weight-bold">{{ commaFormat(row.amount) }}원</span>
        </v-col>
      </v-row>
    </template>
  </section>
</template>

<script>
import { commaFormat } from '@/util'
export default {
  props: ['item', 'filter'],
  methods: {
    commaFormat,
    sumByProperties(array, names) {
      return array.reduce((total, cur) => {
        return names.reduce((total, name) => {
          return (total += cur[name])
        }, total)
      }, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.row {
  .col:last-child {
    text-align: right;
  }

  &.detail {
    margin-top: 0;
    padding-top: 0;
    padding-bottom: 0;

    .col {
      padding-top: 10px;
      padding-bottom: 0;
    }
  }

  &.subject:not(:first-of-type) {
    margin-top: 30px;
  }
}

section {
  padding-bottom: 45px !important;

  &:not(:last-child) {
    border-bottom: 1px solid $gray-30;
  }
}
</style>
